
import {defineComponent} from 'vue'
import db from '../db'
   export default defineComponent({
       name: 'OrderingInfo',
       props: ['orderData', 'refKey'],
       setup(props){

           const removeOrdering = (index: number): void => {
               const remove = confirm('確定刪除此筆訂購嗎')
               if(remove){
                   const orderRef = db.database().ref('orders/'+ props.refKey.trim())
                   const data = props.orderData.orderings
                   data.splice(index, 1)
                   orderRef.update({orderings: data})
               }
           }
           return{
               removeOrdering,
           }
       }
   })
